import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import {ExerciseTask, TaskOption, Exercise} from '../server/ExamServer'
import ExamTask from "./ExamTask";
import ExamExerciseResultListItem from "./ExamExerciseResultListItem";



const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExamExerciseResultListProps {
    exercise:Exercise
}

export interface ExamExerciseResultListState {

}


class ExamExerciseResultList extends React.Component<ExamExerciseResultListProps, ExamExerciseResultListState> {


    constructor(props: ExamExerciseResultListProps) {
        super(props);
    }

    

    render() {

        const {exercise} = this.props
        return (
            <div style={{margin:theme.spacing(0), marginTop:theme.spacing(2)}}>
                <ExamExerciseResultListItem tasks={exercise.tasks} name={"Overall"} overall={true}/>
                <br/>
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 0})} name={"Starter"} />
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 1})} name={"Elementary"} />
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 2})} name={"Pre-intermediate"} />
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 3})} name={"Intermediate"} />
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 4})} name={"Upper Intermediate"} />
                <ExamExerciseResultListItem  overall={false} tasks={exercise.tasks.filter(task=>{return task.tier === 5})} name={"Advanced"} />

            </div>

        );
    }
}

export default ExamExerciseResultList;
